import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { personalInfo } from '../../../../config/personalInfo';
import { Wordmark } from '../../atoms';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { t } = useLanguage();

    const quickLinks = [
        { name: t('navigation.home'), href: '#home' },
        { name: t('navigation.about'), href: '#about' },
        { name: t('navigation.skills'), href: '#skills' },
        { name: t('navigation.projects'), href: '#projects' },
        { name: t('navigation.contact'), href: '#contact' },
    ];

    const socialLinks = [
        { name: 'GitHub', url: personalInfo.social.github },
        { name: 'LinkedIn', url: personalInfo.social.linkedin },
        { name: 'Twitter', url: personalInfo.social.twitter },
        { name: 'Email', url: personalInfo.social.email },
    ];

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <footer className="border-t border-white/5 bg-ink text-fg">
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
                    <div className="lg:col-span-2">
                        <div className="mb-6">
                            <Wordmark size="footer" />
                        </div>
                        <p className="mb-6 max-w-md leading-relaxed text-muted">
                            {t('footer.description')}
                        </p>
                        <div className="flex flex-wrap gap-3">
                            {socialLinks
                                .filter((social) => social.url)
                                .map((social, index) => (
                                    <a
                                        key={index}
                                        href={social.url!}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="border border-white/15 px-3 py-2 text-sm text-muted transition-colors hover:border-accent hover:text-accent"
                                        aria-label={social.name}
                                    >
                                        {social.name}
                                    </a>
                                ))}
                        </div>
                    </div>

                    <div>
                        <h3 className="mb-6 font-display text-lg font-semibold">
                            {t('footer.quickLinks')}
                        </h3>
                        <ul className="space-y-3">
                            {quickLinks.map((link, index) => (
                                <li key={index}>
                                    <a
                                        href={link.href}
                                        className="text-muted transition-colors hover:text-highlight"
                                    >
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="mb-6 font-display text-lg font-semibold">
                            {t('footer.contact')}
                        </h3>
                        <div className="space-y-3 text-muted">
                            {personalInfo.social.email && (
                                <a
                                    href={personalInfo.social.email}
                                    className="block transition-colors hover:text-accent"
                                >
                                    {personalInfo.email}
                                </a>
                            )}
                            <p>{personalInfo.location}</p>
                        </div>
                    </div>
                </div>

                <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
                    <div className="text-sm text-muted">
                        © {currentYear} n33no. {t('footer.rights')}
                    </div>
                </div>
            </div>

            <button
                type="button"
                onClick={scrollToTop}
                className="fixed bottom-8 right-8 z-50 border border-accent bg-ink p-3 text-accent transition-colors hover:bg-accent hover:text-fg"
                aria-label={t('common.backToTop')}
            >
                <svg className="mx-auto h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                </svg>
            </button>
        </footer>
    );
};

export { Footer };
